var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector51(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 309,
    viewBox: "0 0 122 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.467 307.581C305.079 288.666 301.372 284.547 286.556 265.138C282.926 260.383 277.214 251.139 271.759 239.722C270.124 236.305 268.642 232.917 267.283 229.576C257.589 205.669 256.221 178.886 258.473 152.435C264.223 84.9457 227.691 24.0338 172.38 6.27647C116.964 -11.5188 55.4475 17.7414 25.4256 63.4016C21.5196 69.3428 4.28953 97.3787 1.74256 128.138C-6.326 225.258 87.7502 264.066 230.894 293.449C233.678 294.019 246.936 296.192 249.749 296.581L328.477 307.581H328.467Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector51);
export default __webpack_public_path__ + "static/media/vector5-1.92eeafc43b768bc1c91f269e5c075329.svg";
export { ForwardRef as ReactComponent };